'use client';

import { createContext, useContext } from 'react';

interface SettlementFormContextValue {
  accountValidation: {
    error: string | null;
    isValidating: boolean;
    onVerify: () => void;
  };
  handlers: {
    onAccountFieldChange: (
      fieldName: 'bankName' | 'accountNumber' | 'accountHolder',
      fieldOnChange: (value: string) => void,
    ) => (value: string) => void;
    onAccountInputChange: (
      fieldName: 'bankName' | 'accountNumber' | 'accountHolder',
      fieldOnChange: (value: string) => void,
    ) => (e: React.ChangeEvent<HTMLInputElement>) => void;
  };
}

const SettlementFormContext = createContext<SettlementFormContextValue | null>(null);

export const SettlementFormProvider = SettlementFormContext.Provider;

export const useSettlementFormContext = () => {
  const context = useContext(SettlementFormContext);
  if (!context) {
    throw new Error('useSettlementFormContext must be used within SettlementFormProvider');
  }
  return context;
};
